import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useState } from "react";

export const useUpdateQueryParams = () => {
  const [loading, setLoading] = useState(false)
  const r = useRouter();
  const queryParams = useSearchParams();
  const pathname = usePathname();


  const createQueryString = (name: string, value?: string) => {
    const params = new URLSearchParams(queryParams);
    value ? params.set(name, value) : params.delete(name);
    return params.toString();
  };

  const updateQueryParam = (name: string, value?: string | number) => {
    setLoading(true)
    r.push(
      `${pathname}?${createQueryString(name, value ? `${value}` : undefined)}`
    );
  };

  const updateQueryParams = (params: Record<string, any>) => {
    setLoading(true)
    const newQueryParams = new URLSearchParams(queryParams);

    Object.entries(params).forEach(({ key, value }: Record<string, any>) => {
      if (value != null) {
        newQueryParams.set(key, value);
      } else {
        newQueryParams.delete(key);
      }
    });

    r.push(`/${pathname}?${newQueryParams.toString()}`);
  };

  return { updateQueryParam, updateQueryParams, loading, setLoading };
};
